export default {
  APP_NAME: 'yola-public-roadmap',
};
